<template>
  <div class="dropdown" v-show="(this.$store.getters.right__folder_tree || this.$store.getters.right__file_number) && isShowUpload">
    <div
      class="dropdown-toggle"
      id="dropdownMenu2"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="true"
    >
      <i class="iconfont icon-upload"></i>
      上传
      <span class="caret"></span>
    </div>
    <ul
      class="dropdown-menu dropdown-menu-right"
      aria-labelledby="dropdownMenu2"
    >
      <li v-if="this.$store.getters.right__folder_tree">
        <a @click="handleUploadFolder">
          <i class="iconfont icon-folder-upload"></i>
          上传文件夹
        </a>
      </li>
      <li v-if="this.$store.getters.right__file_number">
        <a @click="handleUploadFiles">
          <i class="iconfont icon-file"></i>
          上传文件
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import Bus from "@/utils/bus";
export default {
  props: {
    isShowUpload: Boolean,
  },
  name: "Upload",
  data() {
    return {};
  },
  methods: {
    handleUploadFolder() {
      Bus.$emit("openUploaderFolder", {
        // target: "//localhost:3000/upload1",
        // chunkSize: 10 * 1024 * 1024
      });
    },
    handleUploadFiles() {
      Bus.$emit("openUploaderFile", {
        // target: "//localhost:3000/upload2",
        // chunkSize: 10 * 1024 * 1024
      });
    },
  },
  computed: {
    isList() {
      return this.$store.state.drive.isList;
    },
  },
  mounted() {
    // 文件选择后的回调
    Bus.$on("fileAdded", () => {
      // console.log("文件已选择");
    });
    // 文件上传成功的回调
    Bus.$on("fileSuccess", (isTop) => {
      if (isTop) {
        this.$store.dispatch("getInfo").then(() => {
          if (!this.isList) {
            this.$store.dispatch("getImgPath");
          }
        });
      }
      // console.log("文件上传成功");
    });
  },
  destroyed() {
    Bus.$off("fileAdded");
    Bus.$off("fileSuccess");
  },
};
</script>

<style scoped>
</style>